import React, { useCallback, useEffect, useRef } from "react"
import { useHistory } from "react-router"
import { useStoreState, useStoreActions, StateMapper } from "easy-peasy"
import { AppDataStore } from "../appData/types"
import { gen, IUser, swimminglyApi } from "./utils"
import _ from "lodash"
import { message } from "antd"

export default function ActivateAndLogin({
  activationToken,
  clubToken
}: {
  activationToken: string,
  clubToken?: string|null
}) {
  const user = useStoreState((state: StateMapper<AppDataStore>) => state.user)
  const setUser = useStoreActions((actions: AppDataStore) => actions.setUser)

  const history = useHistory()
  const calledRef = useRef<boolean>(false)

  const activateUser = useCallback(
    ({
      activationToken,
      user,
      setUser,
    }: {
      activationToken: string
      user: IUser | null
      setUser: (value: IUser | null) => void
    }) => {
      swimminglyApi
        .get(gen(`/api/activateUser/${activationToken}`))
        .then(async (data) => {
          if (data?.status === "success" && data?.user?.isActive) {
            if (user?.userId && user.userId === data.user.userId) {
              setUser({ ...user, isActive: true })
              await new Promise((resolve) => setTimeout(resolve, 100))
              message.success("Account activated!", 2)
            } else {
              try {
                const whoami = await swimminglyApi.get(gen("/api/whoami"))
                if (whoami?.user && whoami.user.userId === data.user.userId) {
                  setUser(whoami.user)
                  await new Promise((resolve) => setTimeout(resolve, 50))
                  message.success("Account activated!", 2)
                }
              } catch (err) {
                // silently ignore whoami fetch errors; activation succeeded server-side
              }
            }
          } else {
            // activation did not succeed; no-op before redirect
          }
        })
        .finally(() => {
          if (_.isNil(clubToken)) {
            history.push("/")

          } else {
            history.push(`/clubs/register/${clubToken}`)
          }
        })
    },
    [history, clubToken],
  )

  useEffect(() => {
    if (!calledRef.current) {
      calledRef.current = true
      activateUser({ activationToken, user, setUser })
    } else {
      // already invoked once on mount; skip
    }
    return () => {}
  }, [activationToken, user, setUser, history, activateUser])

  return <p>loading...</p>
}
